import PosCartActions from '../../../actions/PosCartActions';
import NotificationActions from '../../../actions/NotificationActions';

import UserStore from '../../../stores/UserStore';

import AjaxPromises from '../../../utils/AjaxPromises';
import { endPoints as PosEndPoints } from '../../../constants/PosConstants';

class EditWholeSale extends React.Component {

    constructor(props) {
        super(props);

        var pricePerItem = 0;
        if (this.props.item.WgtCnt !== 'Wgt')
            pricePerItem = parseFloat(this.props.item.TotalCost / this.props.item.QtyAllocated).toFixed(2);
        else
            pricePerItem = parseFloat(this.props.item.TotalCost / this.props.item.Grams).toFixed(2);

        this.state = {
            quantity        : this.props.item.QtyAllocated,
            pricePerItem    : pricePerItem,
            discountAmount  : this.props.item.DiscountAmt,
            itemTotalPrice  : this.props.item.TotalCost
        };

        this.increaseByQty = this.increaseByQty.bind(this);
        this.increaseByWgt = this.increaseByWgt.bind(this);
        this.updateTotal = this.updateTotal.bind(this);
    }

    componentWillReceiveProps(next) {
        var pricePerItem = 0;

        if (!this.props.item)
            return;

        if (this.props.item.WgtCnt !== 'Wgt')
            pricePerItem = parseFloat(this.props.item.TotalCost / this.props.item.QtyAllocated).toFixed(2);
        else
            pricePerItem = parseFloat(this.props.item.TotalCost / this.props.item.Grams).toFixed(2);

        this.state = {
            quantity        : next.item.QtyAllocated,
            pricePerItem    : pricePerItem,
            discountAmount  : next.item.DiscountAmt,
            itemTotalPrice  : next.item.TotalCost
        };
    }

    updateTotal() {
        this.setState({
            itemTotalPrice : this.state.quantity * this.state.pricePerItem
        });
    }

    increaseByQty() {
        var self = this;

        var item     = this.props.item;
        var guest    = this.props.guest;
        var quantity = parseInt(this.state.quantity);

        if (!quantity || quantity.length < 1)
            return;

        var formData = UserStore.getApiData();
        formData.SearchString = item.SerialNo;

        AjaxPromises.POST(PosEndPoints.POS_PRODUCT_SEARCH,
            formData
        ).then(res => {
            if (res.Data.length !== 1) {
                NotificationActions.addNotification({
                    type : 'alert',
                    body : 'Something went wrong'
                });
            } else {
                item = res.Data[0];
                if (self.state.quantity > item.TotalAvailable) {
                    NotificationActions.addNotification({
                        type : 'alert',
                        body : 'Only '+item.TotalAvailable+' left'
                    });
                } else {
                    PosCartActions.removeItemFromCart(item, guest, self.props.item.QtyAllocated, true);

                    item.DiscountAmount = self.state.discountAmount;
                    item.UnitPrice      = self.state.pricePerItem;

                    setTimeout(() => {
                        PosCartActions.addItemToCart(item, self.props.guest, self.state.quantity); // self.props.item.
                    }, 200);
                }
            }
        });
    }

    increaseByWgt() {
        var self = this;

        var item     = this.props.item;
        var guest    = this.props.guest;
        var quantity = parseInt(this.state.quantity);

        if (!quantity || quantity.length < 1)
            return;

        AjaxPromises.POST(PosEndPoints.POS_PRODUCT_SEARCH, UserStore.getApiData({
            SearchString : item.SerialNo
        })).then(res => {
            if (res.Data.length !== 1) {
                NotificationActions.addNotification({
                    type : 'alert',
                    body : 'Something went wrong'
                });
            } else {
                item = res.Data[0];
                if (self.state.quantity > item.TotalGrams) {
                    NotificationActions.addNotification({
                        type : 'alert',
                        body : 'Only '+item.TotalGrams+'g left'
                    });
                } else {
                    PosCartActions.removeItemFromCart(item, guest, 1, true);

                    item.DiscountAmount = self.state.discountAmount;
                    item.UnitPrice      = self.state.pricePerItem;

                    setTimeout(() => {
                        item.CannbisProduct  = 'Yes';

                        PosCartActions.addBulkItemToCart(
                            UserStore.getApiData({
                                ShipmentId  : guest.ShipmentId,
                                SubTotal    : self.state.itemTotalPrice,
                                SerialNo    : item.SerialNo,
                                Grouping    : 'No',
                                ProdId      : item.ProductId,
                                AvailOz     : item.TotalOz,
                                UnitPrice   : self.state.itemTotalPrice,
                                OrderId     : 0,
                                DiscountAmt : self.state.discountAmount,
                                Comments    : '',
                                InvId       : 0,
                                Weight      : quantity
                            }),
                            guest,
                            item
                        );
                    }, 200);
                }
            }
        });
    }

    render() {
        var self = this;

        var item      = this.props.item;
        var guest     = this.props.guest;

        return (
            <div className='edit-wholesale'>

                <input
                    type='number'
                    id='last-four'
                    value={this.state.quantity}
                    onChange={(e) => { this.setState({ quantity : e.target.value.replace(/[^0-9.]/g, '')}, () => { self.updateTotal() }); }} />

                <div className='add-wholesale__label'>
                    Quantity
                </div>
                <div />

                <input
                    type='number'
                    id='last-four'
                    value={this.state.pricePerItem}
                    onChange={(e) => {
                        this.setState({
                            pricePerItem : e.target.value,
                            itemTotalPrice : e.target.value * this.state.quantity
                        });
                    }} />

                <div className='add-wholesale__label'>
                    Price per Item
                </div>
                <div />

                <input
                    type='number'
                    id='last-four'
                    value={this.state.itemTotalPrice}
                    onChange={(e) => {
                        this.setState({
                            pricePerItem : e.target.value / this.state.quantity,
                            itemTotalPrice : e.target.value
                        });
                    }} />

                <div className='add-wholesale__label'>
                    Item Total Price
                </div>
                <div />

                <input
                    type='number'
                    id='last-four'
                    value={this.state.discountAmount}
                    onChange={(e) => { this.setState({ discountAmount : e.target.value }); }} />

                <div className='add-wholesale__label'>
                    Discount Amount
                </div>
                <div />

                <div
                    className='edit-wholesale__save'
                    onClick={item.WgtCnt !== 'Wgt' ? this.increaseByQty : this.increaseByWgt}>

                    UPDATE
                </div>
            </div>
        );
    }
}

export default EditWholeSale;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/cart/EditWholeSale.react.jsx